module.exports = [
    "ADANA/Feke - Feke Malmüdürlüğü",
    "ADANA/Karaisalı - Karaisalı Malmüdürlüğü",
    "ADANA/Pozantı - Pozantı Malmüdürlüğü",
    "ADANA/Saimbeyli - Saimbeyli Malmüdürlüğü",
    "ADANA/Tufanbeyli - Tufanbeyli Malmüdürlüğü",
    "ADANA/Yumurtalık - Yumurtalık Malmüdürlüğü",
    "ADANA/Aladağ - Aladağ Malmüdürlüğü",
    "ADANA/İmamoğlu - İmamoğlu Malmüdürlüğü",
    "ADANA/Ceyhan - Ceyhan Vergi Dairesi Müdürlüğü",
    "ADANA/Kozan - Kozan Vergi Dairesi Müdürlüğü",
    "ADANA/Karataş - Karataş Vergi Dairesi Müdürlüğü",
    "ADANA/Merkez - Adana İhtisas Vergi Dairesi Müdürlüğü",
    "ADANA/Merkez - 5 Ocak Vergi Dairesi Müdürlüğü",
    "ADANA/Merkez - Yüreğir Vergi Dairesi Müdürlüğü",
    "ADANA/Merkez - Seyhan Vergi Dairesi Müdürlüğü",
    "ADANA/Merkez - Ziyapaşa Vergi Dairesi Müdürlüğü",
    "ADANA/Merkez - Çukurova Vergi Dairesi Müdürlüğü",
    "ADIYAMAN/Besni - Besni Malmüdürlüğü",
    "ADIYAMAN/Çelikhan - Çelikhan Malmüdürlüğü",
    "ADIYAMAN/Gerger - Gerger Malmüdürlüğü",
    "ADIYAMAN/Gölbaşı - Gölbaşı Malmüdürlüğü",
    "ADIYAMAN/Samsat - Samsat Malmüdürlüğü",
    "ADIYAMAN/Sincik - Sincik Malmüdürlüğü",
    "ADIYAMAN/Tut - Tut Malmüdürlüğü",
    "ADIYAMAN/Merkez - Adıyaman Vergi Dairesi Müdürlüğü",
    "ADIYAMAN/Kahta - Kahta Vergi Dairesi Müdürlüğü",
    "AFYONKARAHİSAR/Dazkırı - Dazkırı Malmüdürlüğü",
    "AFYONKARAHİSAR/İhsaniye - İhsaniye Malmüdürlüğü",
    "AFYONKARAHİSAR/Sinanpaşa - Sinanpaşa Malmüdürlüğü",
    "AFYONKARAHİSAR/Sultandağı - Sultandağı Malmüdürlüğü",
    "AFYONKARAHİSAR/Şuhut - Şuhut Malmüdürlüğü",
    "AFYONKARAHİSAR/Başmakçı - Başmakçı Malmüdürlüğü",
    "AFYONKARAHİSAR/Bayat - Bayat Malmüdürlüğü",
    "AFYONKARAHİSAR/Çobanlar - Çobanlar Malmüdürlüğü",
    "AFYONKARAHİSAR/Evciler - Evciler Malmüdürlüğü",
    "AFYONKARAHİSAR/Hocalar - Hocalar Malmüdürlüğü",
    "AFYONKARAHİSAR/Kızılören - Kızılören Malmüdürlüğü",
    "AFYONKARAHİSAR/Merkez - Tınaztepe Vergi Dairesi Müdürlüğü",
    "AFYONKARAHİSAR/Çay - Çay Vergi Dairesi Müdürlüğü",
    "AFYONKARAHİSAR/Dinar - Dinar Vergi Dairesi Müdürlüğü",
    "AFYONKARAHİSAR/Bolvadin - Bolvadin Vergi Dairesi Müdürlüğü",
    "AFYONKARAHİSAR/Emirdağ - Emirdağ Vergi Dairesi Müdürlüğü",
    "AFYONKARAHİSAR/Sandıklı - Sandıklı Vergi Dairesi Müdürlüğü",
    "AFYONKARAHİSAR/İscehisar - İscehisar Vergi Dairesi Müdürlüğü",
    "AFYONKARAHİSAR/Merkez - Kocatepe Vergi Dairesi Müdürlüğü",
    "AĞRI/Diyadin - Diyadin Malmüdürlüğü",
    "AĞRI/Eleşkirt - Eleşkirt Malmüdürlüğü",
    "AĞRI/Hamur - Hamur Malmüdürlüğü",
    "AĞRI/Taşlıçay - Taşlıçay Malmüdürlüğü",
    "AĞRI/Tutak - Tutak Malmüdürlüğü",
    "AĞRI/Merkez - Ağrı Vergi Dairesi Müdürlüğü",
    "AĞRI/Doğubeyazıt - Doğubeyazıt Vergi Dairesi Müdürlüğü",
    "AĞRI/Patnos - Patnos Vergi Dairesi Müdürlüğü",
    "AMASYA/Göynücek - Göynücek Malmüdürlüğü",
    "AMASYA/Hamamözü - Hamamözü Malmüdürlüğü",
    "AMASYA/Merkez - Amasya Vergi Dairesi Müdürlüğü",
    "AMASYA/Merzifon - Merzifon Vergi Dairesi Müdürlüğü",
    "AMASYA/Gümüşhacıköy - Gümüşhacıköy Vergi Dairesi Müdürlüğü",
    "AMASYA/Taşova - Taşova Vergi Dairesi Müdürlüğü",
    "AMASYA/Suluova - Suluova Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez- (56) - Ayaş Malmüdürlüğü",
    "ANKARA/Merkez- (56) - Balâ Malmüdürlüğü",
    "ANKARA/Çamlıdere - Çamlıdere Malmüdürlüğü",
    "ANKARA/Güdül - Güdül Malmüdürlüğü",
    "ANKARA/Merkez- (56) - Kalecik Malmüdürlüğü",
    "ANKARA/Kızılcahamam - Kızılcahamam Malmüdürlüğü",
    "ANKARA/Nallıhan - Nallıhan Malmüdürlüğü",
    "ANKARA/Merkez- (56) - Akyurt Malmüdürlüğü",
    "ANKARA/Evren - Evren Malmüdürlüğü",
    "ANKARA/Polatlı - Polatlı Vergi Dairesi Müdürlüğü",
    "ANKARA/Şereflikoçhisar - Şereflikoçhisar Vergi Dairesi Müdürlüğü",
    "ANKARA/Beypazarı - Beypazarı Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez- (56) - Çubuk Vergi Dairesi Müdürlüğü",
    "ANKARA/Haymana - Haymana Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez- (56) - Elmadağ Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez - Veraset ve İntikal Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez - Kavaklıdere Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez - Maltepe Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez - Yenimahalle Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez - Çankaya Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez - Kızılbey Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez - Mithatpaşa Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez - Ulus Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez - Yıldırım Beyazıt Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez - Seğmenler Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez - Dikimevi Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez - Doğanbey Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez - Yeğenbey Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez - Hitit Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez - Yahya Galip Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez - Muhammet Karagüzel Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez - Ostim Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez - Gölbaşı Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez - Sincan Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez - Dışkapı Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez - Etimesgut Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez - Başkent Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez - Cumhuriyet Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez - Keçiören Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez- (56) - Kahramankazan Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez - Anadolu İhtisas Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez - Ankara İhtisas Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez - Harçlar Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez - Ankara Kurumlar Vergi Dairesi Müdürlüğü",
    "ANKARA/Merkez - İvedik Vergi Dairesi Müdürlüğü",
    "ANTALYA/Akseki - Akseki Malmüdürlüğü",
    "ANTALYA/Finike - Finike Malmüdürlüğü",
    "ANTALYA/Gazipaşa - Gazipaşa Malmüdürlüğü",
    "ANTALYA/Gündoğmuş - Gündoğmuş Malmüdürlüğü",
    "ANTALYA/Kaş - Kaş Malmüdürlüğü",
    "ANTALYA/Demre - Demre Malmüdürlüğü",
    "ANTALYA/İbradı - İbradı Malmüdürlüğü",
    "ANTALYA/Alanya - Alanya Vergi Dairesi Müdürlüğü",
    "ANTALYA/Serik - Serik Vergi Dairesi Müdürlüğü",
    "ANTALYA/Manavgat - Manavgat Vergi Dairesi Müdürlüğü",
    "ANTALYA/Elmalı - Elmalı Vergi Dairesi Müdürlüğü",
    "ANTALYA/Kemer - Kemer Vergi Dairesi Müdürlüğü",
    "ANTALYA/Kumluca - Kumluca Vergi Dairesi Müdürlüğü",
    "ANTALYA/Merkez - Üçkapılar Vergi Dairesi Müdürlüğü",
    "ANTALYA/Merkez - Kalekapı Vergi Dairesi Müdürlüğü",
    "ANTALYA/Merkez - Muratpaşa Vergi Dairesi Müdürlüğü",
    "ANTALYA/Merkez - Düden Vergi Dairesi Müdürlüğü",
    "ANTALYA/Merkez - Antalya Kurumlar Vergi Dairesi Müdürlüğü",
    "ANTALYA/Merkez - Antalya İhtisas Vergi Dairesi Müdürlüğü",
    "ANTALYA/Korkuteli - Korkuteli Vergi Dairesi Müdürlüğü",
    "ARTVİN/Ardanuç - Ardanuç Malmüdürlüğü",
    "ARTVİN/Borçka - Borçka Malmüdürlüğü",
    "ARTVİN/Şavşat - Şavşat Malmüdürlüğü",
    "ARTVİN/Yusufeli - Yusufeli Malmüdürlüğü",
    "ARTVİN/Murgul - Murgul Malmüdürlüğü",
    "ARTVİN/Merkez - Artvin Vergi Dairesi Müdürlüğü",
    "ARTVİN/Hopa - Hopa Vergi Dairesi Müdürlüğü",
    "ARTVİN/Arhavi - Arhavi Vergi Dairesi Müdürlüğü",
    "AYDIN/Bozdoğan - Bozdoğan Malmüdürlüğü",
    "AYDIN/Karacasu - Karacasu Malmüdürlüğü",
    "AYDIN/Koçarlı - Koçarlı Malmüdürlüğü",
    "AYDIN/Kuyucak - Kuyucak Malmüdürlüğü",
    "AYDIN/Sultanhisar - Sultanhisar Malmüdürlüğü",
    "AYDIN/Yenipazar - Yenipazar Malmüdürlüğü",
    "AYDIN/Buharkent - Buharkent Malmüdürlüğü",
    "AYDIN/İncirliova - İncirliova Malmüdürlüğü",
    "AYDIN/Karpuzlu - Karpuzlu Malmüdürlüğü",
    "AYDIN/Köşk - Köşk Malmüdürlüğü",
    "AYDIN/Merkez - Efeler Vergi Dairesi Müdürlüğü",
    "AYDIN/Nazilli - Nazilli Vergi Dairesi Müdürlüğü",
    "AYDIN/Söke - Söke Vergi Dairesi Müdürlüğü",
    "AYDIN/Çine - Çine Vergi Dairesi Müdürlüğü",
    "AYDIN/Germencik - Germencik Vergi Dairesi Müdürlüğü",
    "AYDIN/Kuşadası - Kuşadası Vergi Dairesi Müdürlüğü",
    "AYDIN/Merkez - Güzelhisar Vergi Dairesi Müdürlüğü",
    "AYDIN/Didim - Didim Vergi Dairesi Müdürlüğü",
    "BALIKESİR/Balya - Balya Malmüdürlüğü",
    "BALIKESİR/Havran - Havran Malmüdürlüğü",
    "BALIKESİR/İvrindi - İvrindi Malmüdürlüğü",
    "BALIKESİR/Kepsut - Kepsut Malmüdürlüğü",
    "BALIKESİR/Manyas - Manyas Malmüdürlüğü",
    "BALIKESİR/Savaştepe - Savaştepe Malmüdürlüğü",
    "BALIKESİR/Marmara - Marmara Malmüdürlüğü",
    "BALIKESİR/Gömeç - Gömeç Malmüdürlüğü",
    "BALIKESİR/Merkez - Karesi Vergi Dairesi Müdürlüğü",
    "BALIKESİR/Ayvalık - Ayvalık Vergi Dairesi Müdürlüğü",
    "BALIKESİR/Bandırma - Bandırma Vergi Dairesi Müdürlüğü",
    "BALIKESİR/Burhaniye - Burhaniye Vergi Dairesi Müdürlüğü",
    "BALIKESİR/Edremit - Edremit Vergi Dairesi Müdürlüğü",
    "BALIKESİR/Gönen - Gönen Vergi Dairesi Müdürlüğü",
    "BALIKESİR/Susurluk - Susurluk Vergi Dairesi Müdürlüğü",
    "BALIKESİR/Erdek - Erdek Vergi Dairesi Müdürlüğü",
    "BALIKESİR/Bigadiç - Bigadiç Vergi Dairesi Müdürlüğü",
    "BALIKESİR/Sındırgı - Sındırgı Vergi Dairesi Müdürlüğü",
    "BALIKESİR/Dursunbey - Dursunbey Vergi Dairesi Müdürlüğü",
    "BALIKESİR/Merkez - Kurtdereli Vergi Dairesi Müdürlüğü",
    "BİLECİK/Gölpazarı - Gölpazarı Malmüdürlüğü",
    "BİLECİK/Osmaneli - Osmaneli Malmüdürlüğü",
    "BİLECİK/Pazaryeri - Pazaryeri Malmüdürlüğü",
    "BİLECİK/Söğüt - Söğüt Malmüdürlüğü",
    "BİLECİK/Yenipazar - Yenipazar Malmüdürlüğü",
    "BİLECİK/İnhisar - İnhisar Malmüdürlüğü",
    "BİLECİK/Merkez - Bilecik Vergi Dairesi Müdürlüğü",
    "BİLECİK/Bozüyük - Bozüyük Vergi Dairesi Müdürlüğü",
    "BİNGÖL/Genç - Genç Malmüdürlüğü",
    "BİNGÖL/Karlıova - Karlıova Malmüdürlüğü",
    "BİNGÖL/Kiğı - Kiğı Malmüdürlüğü",
    "BİNGÖL/Solhan - Solhan Malmüdürlüğü",
    "BİNGÖL/Adaklı - Adaklı Malmüdürlüğü",
    "BİNGÖL/Yayladere - Yayladere Malmüdürlüğü",
    "BİNGÖL/Yedisu - Yedisu Malmüdürlüğü",
    "BİNGÖL/Merkez - Bingöl Vergi Dairesi Müdürlüğü",
    "BİTLİS/Adilcevaz - Adilcevaz Malmüdürlüğü",
    "BİTLİS/Ahlat - Ahlat Malmüdürlüğü",
    "BİTLİS/Hizan - Hizan Malmüdürlüğü",
    "BİTLİS/Mutki - Mutki Malmüdürlüğü",
    "BİTLİS/Göroymak - Güroymak Malmüdürlüğü",
    "BİTLİS/Merkez - Bitlis Vergi Dairesi Müdürlüğü",
    "BİTLİS/Tatvan - Tatvan Vergi Dairesi Müdürlüğü",
    "BOLU/Göynük - Göynük Malmüdürlüğü",
    "BOLU/Kıbrıscık - Kıbrıscık Malmüdürlüğü",
    "BOLU/Mengen - Mengen Malmüdürlüğü",
    "BOLU/Mudurnu - Mudurnu Malmüdürlüğü",
    "BOLU/Seben - Seben Malmüdürlüğü",
    "BOLU/Dörtdivan - Dörtdivan Malmüdürlüğü",
    "BOLU/Yeniçağa - Yeniçağa Malmüdürlüğü",
    "BOLU/Merkez - Bolu Vergi Dairesi Müdürlüğü",
    "BOLU/Gerede - Gerede Vergi Dairesi Müdürlüğü",
    "BURDUR/Ağlasun - Ağlasun Malmüdürlüğü",
    "BURDUR/Gölhisar - Gölhisar Malmüdürlüğü",
    "BURDUR/Tefenni - Tefenni Malmüdürlüğü",
    "BURDUR/Yeşilova - Yeşilova Malmüdürlüğü",
    "BURDUR/Karamanlı - Karamanlı Malmüdürlüğü",
    "BURDUR/Kemer - Kemer Malmüdürlüğü",
    "BURDUR/Altınyayla - Altınyayla Malmüdürlüğü",
    "BURDUR/Çavdır - Çavdır Malmüdürlüğü",
    "BURDUR/Çeltikçi - Çeltikçi Malmüdürlüğü",
    "BURDUR/Merkez - Burdur Vergi Dairesi Müdürlüğü",
    "BURDUR/Bucak - Bucak Vergi Dairesi Müdürlüğü",
    "BURSA/Keles - Keles Malmüdürlüğü",
    "BURSA/Orhaneli - Orhaneli Malmüdürlüğü",
    "BURSA/Harmancık - Harmancık Malmüdürlüğü",
    "BURSA/Büyükorhan - Büyükorhan Malmüdürlüğü",
    "BURSA/Merkez- (56) - Gemlik Vergi Dairesi Müdürlüğü",
    "BURSA/İnegöl - İnegöl Vergi Dairesi Müdürlüğü",
    "BURSA/Karacabey - Karacabey Vergi Dairesi Müdürlüğü",
    "BURSA/Mustafakemalpaşa - Mustafakemalpaşa Vergi Dairesi Müdürlüğü",
    "BURSA/Merkez- (56) - Mudanya Vergi Dairesi Müdürlüğü",
    "BURSA/Orhangazi - Orhangazi Vergi Dairesi Müdürlüğü",
    "BURSA/İznik - İznik Vergi Dairesi Müdürlüğü",
    "BURSA/Yenişehir - Yenişehir Vergi Dairesi Müdürlüğü",
    "BURSA/Merkez - Bursa İhtisas Vergi Dairesi Müdürlüğü",
    "BURSA/Merkez - Osmangazi Vergi Dairesi Müdürlüğü",
    "BURSA/Merkez - Yıldırım Vergi Dairesi Müdürlüğü",
    "BURSA/Merkez - Çekirge Vergi Dairesi Müdürlüğü",
    "BURSA/Merkez - Setbaşı Vergi Dairesi Müdürlüğü",
    "BURSA/Merkez - Uludağ Vergi Dairesi Müdürlüğü",
    "BURSA/Merkez - Yeşil Vergi Dairesi Müdürlüğü",
    "BURSA/Merkez - Nilüfer Vergi Dairesi Müdürlüğü",
    "BURSA/Merkez - Ertuğrulgazi Vergi Dairesi Müdürlüğü",
    "BURSA/Merkez - Gökdere Vergi Dairesi Müdürlüğü",
    "BURSA/Merkez - Bursa Veraset ve Harçlar Vergi Dairesi Müdürlüğü",
    "ÇANAKKALE/Ayvacık - Ayvacık Malmüdürlüğü",
    "ÇANAKKALE/Bayramiç - Bayramiç Malmüdürlüğü",
    "ÇANAKKALE/Bozcaada - Bozcaada Malmüdürlüğü",
    "ÇANAKKALE/Eceabat - Eceabat Malmüdürlüğü",
    "ÇANAKKALE/Ezine - Ezine Malmüdürlüğü",
    "ÇANAKKALE/Gökçeada - Gökçeada Malmüdürlüğü",
    "ÇANAKKALE/Lapseki - Lapseki Malmüdürlüğü",
    "ÇANAKKALE/Yenice - Yenice Malmüdürlüğü",
    "ÇANAKKALE/Merkez - Çanakkale Vergi Dairesi Müdürlüğü",
    "ÇANAKKALE/Biga - Biga Vergi Dairesi Müdürlüğü",
    "ÇANAKKALE/Çan - Çan Vergi Dairesi Müdürlüğü",
    "ÇANAKKALE/Gelibolu - Gelibolu Vergi Dairesi Müdürlüğü",
    "ÇANKIRI/Çerkeş - Çerkeş Malmüdürlüğü",
    "ÇANKIRI/Eldivan - Eldivan Malmüdürlüğü",
    "ÇANKIRI/Ilgaz - Ilgaz Malmüdürlüğü",
    "ÇANKIRI/Kurşunlu - Kurşunlu Malmüdürlüğü",
    "ÇANKIRI/Orta - Orta Malmüdürlüğü",
    "ÇANKIRI/Şabanözü - Şabanözü Malmüdürlüğü",
    "ÇANKIRI/Yapraklı - Yapraklı Malmüdürlüğü",
    "ÇANKIRI/Atkaracalar - Atkaracalar Malmüdürlüğü",
    "ÇANKIRI/Kızılırmak - Kızılırmak Malmüdürlüğü",
    "ÇANKIRI/Bayramören - Bayramören Malmüdürlüğü",
    "ÇANKIRI/Korgun - Korgun Malmüdürlüğü",
    "ÇANKIRI/Merkez - Çankırı Vergi Dairesi Müdürlüğü",
    "ÇORUM/Alaca - Alaca Malmüdürlüğü",
    "ÇORUM/Bayat - Bayat Malmüdürlüğü",
    "ÇORUM/İskilip - İskilip Malmüdürlüğü",
    "ÇORUM/Kargı - Kargı Malmüdürlüğü",
    "ÇORUM/Mecitözü - Mecitözü Malmüdürlüğü",
    "ÇORUM/Ortaköy - Ortaköy Malmüdürlüğü",
    "ÇORUM/Osmancık - Osmancık Malmüdürlüğü",
    "ÇORUM/Boğazkale - Boğazkale Malmüdürlüğü",
    "ÇORUM/Uğurludağ - Uğurludağ Malmüdürlüğü",
    "ÇORUM/Dodurga - Dodurga Malmüdürlüğü",
    "ÇORUM/Oğuzlar - Oğuzlar Malmüdürlüğü",
    "ÇORUM/Laçin - Laçin Malmüdürlüğü",
    "ÇORUM/Merkez - Çorum Vergi Dairesi Müdürlüğü",
    "ÇORUM/Sungurlu - Sungurlu Vergi Dairesi Müdürlüğü",
    "DENİZLİ/Çameli - Çameli Malmüdürlüğü",
    "DENİZLİ/Çardak - Çardak Malmüdürlüğü",
    "DENİZLİ/Güney - Güney Malmüdürlüğü",
    "DENİZLİ/Kale - Kale Malmüdürlüğü",
    "DENİZLİ/Babadağ - Babadağ Malmüdürlüğü",
    "DENİZLİ/Bekilli - Bekilli Malmüdürlüğü",
    "DENİZLİ/Honaz - Honaz Malmüdürlüğü",
    "DENİZLİ/Serinhisar - Serinhisar Malmüdürlüğü",
    "DENİZLİ/Pamukkale - Pamukkale Malmüdürlüğü (Akköy)",
    "DENİZLİ/Baklan - Baklan Malmüdürlüğü",
    "DENİZLİ/Beyağaç - Beyağaç Malmüdürlüğü",
    "DENİZLİ/Bozkurt - Bozkurt Malmüdürlüğü",
    "DENİZLİ/Merkez - Saraylar Vergi Dairesi Müdürlüğü",
    "DENİZLİ/Merkez - Çınar Vergi Dairesi Müdürlüğü",
    "DENİZLİ/Merkez - Gökpınar Vergi Dairesi Müdürlüğü",
    "DENİZLİ/Merkez - Denizli İhtisas Vergi Dairesi Müdürlüğü",
    "DENİZLİ/Sarayköy - Sarayköy Vergi Dairesi Müdürlüğü",
    "DENİZLİ/Acıpayam - Acıpayam Vergi Dairesi Müdürlüğü",
    "DENİZLİ/Tavas - Tavas Vergi Dairesi Müdürlüğü",
    "DENİZLİ/Buldan - Buldan Vergi Dairesi Müdürlüğü",
    "DENİZLİ/Çal - Çal Vergi Dairesi Müdürlüğü",
    "DENİZLİ/Çivril - Çivril Vergi Dairesi Müdürlüğü",
    "DENİZLİ/Merkez - Pamukkale Vergi Dairesi Müdürlüğü",
    "DİYARBAKIR/Çermik - Çermik Malmüdürlüğü",
    "DİYARBAKIR/Çınar - Çınar Malmüdürlüğü",
    "DİYARBAKIR/Çüngüş - Çüngüş Malmüdürlüğü",
    "DİYARBAKIR/Dicle - Dicle Malmüdürlüğü",
    "DİYARBAKIR/Hani - Hani Malmüdürlüğü",
    "DİYARBAKIR/Hazro - Hazro Malmüdürlüğü",
    "DİYARBAKIR/Kulp - Kulp Malmüdürlüğü",
    "DİYARBAKIR/Lice - Lice Malmüdürlüğü",
    "DİYARBAKIR/Silvan - Silvan Malmüdürlüğü",
    "DİYARBAKIR/Eğil - Eğil Malmüdürlüğü",
    "DİYARBAKIR/Kocaköy - Kocaköy Malmüdürlüğü",
    "DİYARBAKIR/Merkez - Gökalp Vergi Dairesi Müdürlüğü",
    "DİYARBAKIR/Merkez - Süleyman Nazif Vergi Dairesi Müdürlüğü",
    "DİYARBAKIR/Merkez - Cahit Sıtkı Tarancı Vergi Dairesi Müdürlüğü",
    "DİYARBAKIR/Ergani - Ergani Vergi Dairesi Müdürlüğü",
    "DİYARBAKIR/Bismil - Bismil Vergi Dairesi Müdürlüğü",
    "EDİRNE/Enez - Enez Malmüdürlüğü",
    "EDİRNE/Lalapaşa - Lalapaşa Malmüdürlüğü",
    "EDİRNE/Meriç - Meriç Malmüdürlüğü",
    "EDİRNE/Süloğlu - Süloğlu Malmüdürlüğü",
    "EDİRNE/Merkez - Arda Vergi Dairesi Müdürlüğü",
    "EDİRNE/Merkez - Kırkpınar Vergi Dairesi Müdürlüğü",
    "EDİRNE/Keşan - Keşan Vergi Dairesi Müdürlüğü",
    "EDİRNE/Uzunköprü - Uzunköprü Vergi Dairesi Müdürlüğü",
    "EDİRNE/Havsa - Havsa Vergi Dairesi Müdürlüğü",
    "EDİRNE/İpsala - İpsala Vergi Dairesi Müdürlüğü",
    "ELAZIĞ/Ağın - Ağın Malmüdürlüğü",
    "ELAZIĞ/Baskil - Baskil Malmüdürlüğü",
    "ELAZIĞ/Karakoçan - Karakoçan Malmüdürlüğü",
    "ELAZIĞ/Keban - Keban Malmüdürlüğü",
    "ELAZIĞ/Maden - Maden Malmüdürlüğü",
    "ELAZIĞ/Palu - Palu Malmüdürlüğü",
    "ELAZIĞ/Sivrice - Sivrice Malmüdürlüğü",
    "ELAZIĞ/Arıcak - Arıcak Malmüdürlüğü",
    "ELAZIĞ/Kovancılar - Kovancılar Malmüdürlüğü",
    "ELAZIĞ/Alacakaya - Alacakaya Malmüdürlüğü",
    "ELAZIĞ/Merkez - Harput Vergi Dairesi Müdürlüğü",
    "ELAZIĞ/Merkez - Hazar Vergi Dairesi Müdürlüğü",
    "ERZİNCAN/Çayırlı - Çayırlı Malmüdürlüğü",
    "ERZİNCAN/İliç - İliç Malmüdürlüğü",
    "ERZİNCAN/Kemah - Kemah Malmüdürlüğü",
    "ERZİNCAN/Kemaliye - Kemaliye Malmüdürlüğü",
    "ERZİNCAN/Refahiye - Refahiye Malmüdürlüğü",
    "ERZİNCAN/Tercan - Tercan Malmüdürlüğü",
    "ERZİNCAN/Üzümlü - Üzümlü Malmüdürlüğü",
    "ERZİNCAN/Otlukbeli - Otlukbeli Malmüdürlüğü",
    "ERZİNCAN/Merkez - Fevzipaşa Vergi Dairesi Müdürlüğü",
    "ERZURUM/Aşkale - Aşkale Malmüdürlüğü",
    "ERZURUM/Çat - Çat Malmüdürlüğü",
    "ERZURUM/Hınıs - Hınıs Malmüdürlüğü",
    "ERZURUM/Horasan - Horasan Malmüdürlüğü",
    "ERZURUM/İspir - İspir Malmüdürlüğü",
    "ERZURUM/Karayazı - Karayazı Malmüdürlüğü",
    "ERZURUM/Narman - Narman Malmüdürlüğü",
    "ERZURUM/Oltu - Oltu Malmüdürlüğü",
    "ERZURUM/Olur - Olur Malmüdürlüğü",
    "ERZURUM/Pasinler - Pasinler Malmüdürlüğü",
    "ERZURUM/Şenkaya - Şenkaya Malmüdürlüğü",
    "ERZURUM/Tekman - Tekman Malmüdürlüğü",
    "ERZURUM/Tortum - Tortum Malmüdürlüğü",
    "ERZURUM/Karaçoban - Karaçoban Malmüdürlüğü",
    "ERZURUM/Uzundere - Uzundere Malmüdürlüğü",
    "ERZURUM/Pazaryolu - Pazaryolu Malmüdürlüğü",
    "ERZURUM/Merkez- (56) - Aziziye Malmüdürlüğü (Ilıca)",
    "ERZURUM/Köprüköy - Köprüköy Malmüdürlüğü",
    "ERZURUM/Merkez - Aziziye Vergi Dairesi Müdürlüğü",
    "ERZURUM/Merkez - Kazımkarabekir Vergi Dairesi Müdürlüğü",
    "ESKİŞEHİR/Mahmudiye - Mahmudiye Malmüdürlüğü",
    "ESKİŞEHİR/Mihalıççık - Mihalıççık Malmüdürlüğü",
    "ESKİŞEHİR/Sarıcakaya - Sarıcakaya Malmüdürlüğü",
    "ESKİŞEHİR/Seyitgazi - Seyitgazi Malmüdürlüğü",
    "ESKİŞEHİR/Alpu - Alpu Malmüdürlüğü",
    "ESKİŞEHİR/Beylikova - Beylikova Malmüdürlüğü",
    "ESKİŞEHİR/İnönü - İnönü Malmüdürlüğü",
    "ESKİŞEHİR/Günyüzü - Günyüzü Malmüdürlüğü",
    "ESKİŞEHİR/Han - Han Malmüdürlüğü",
    "ESKİŞEHİR/Mihalgazi - Mihalgazi Malmüdürlüğü",
    "ESKİŞEHİR/Merkez Başkanlık - Eskişehir Vergi Dairesi Başkanlığı (*)",
    "GAZİANTEP/Araban - Araban Malmüdürlüğü",
    "GAZİANTEP/Merkez- (56) - Oğuzeli Malmüdürlüğü",
    "GAZİANTEP/Yavuzeli - Yavuzeli Malmüdürlüğü",
    "GAZİANTEP/Karkamış - Karkamış Malmüdürlüğü",
    "GAZİANTEP/Nurdağı - Nurdağı Malmüdürlüğü",
    "GAZİANTEP/Nizip - Nizip Vergi Dairesi Müdürlüğü",
    "GAZİANTEP/İslahiye - İslahiye Vergi Dairesi Müdürlüğü",
    "GAZİANTEP/Merkez - Gaziantep İhtisas Vergi Dairesi Müdürlüğü",
    "GAZİANTEP/Merkez - Suburcu Vergi Dairesi Müdürlüğü",
    "GAZİANTEP/Merkez - Şehitkâmil Vergi Dairesi Müdürlüğü",
    "GAZİANTEP/Merkez - Şahinbey Vergi Dairesi Müdürlüğü",
    "GAZİANTEP/Merkez - Gazikent Vergi Dairesi Müdürlüğü",
    "GAZİANTEP/Merkez - Kozanlı Vergi Dairesi Müdürlüğü",
    "GİRESUN/Alucra - Alucra Malmüdürlüğü",
    "GİRESUN/Dereli - Dereli Malmüdürlüğü",
    "GİRESUN/Espiye - Espiye Malmüdürlüğü",
    "GİRESUN/Eynesil - Eynesil Malmüdürlüğü",
    "GİRESUN/Görele - Görele Malmüdürlüğü",
    "GİRESUN/Keşap - Keşap Malmüdürlüğü",
    "GİRESUN/Şebinkarahisar - Şebinkarahisar Malmüdürlüğü",
    "GİRESUN/Tirebolu - Tirebolu Malmüdürlüğü",
    "GİRESUN/Piraziz - Piraziz Malmüdürlüğü",
    "GİRESUN/Yağlıdere - Yağlıdere Malmüdürlüğü",
    "GİRESUN/Çanakçı - Çanakçı Malmüdürlüğü",
    "GİRESUN/Güce - Güce Malmüdürlüğü",
    "GİRESUN/Çamoluk - Çamoluk Malmüdürlüğü",
    "GİRESUN/Doğankent - Doğankent Malmüdürlüğü",
    "GİRESUN/Merkez - Giresun Vergi Dairesi Müdürlüğü",
    "GİRESUN/Bulancak - Bulancak Vergi Dairesi Müdürlüğü",
    "GÜMÜŞHANE/Kelkit - Kelkit Malmüdürlüğü",
    "GÜMÜŞHANE/Şiran - Şiran Malmüdürlüğü",
    "GÜMÜŞHANE/Torul - Torul Malmüdürlüğü",
    "GÜMÜŞHANE/Köse - Köse Malmüdürlüğü",
    "GÜMÜŞHANE/Kürtün - Kürtün Malmüdürlüğü",
    "GÜMÜŞHANE/Merkez - Gümüşhane Vergi Dairesi Müdürlüğü",
    "HAKKARİ/Çukurca - Çukurca Malmüdürlüğü",
    "HAKKARİ/Şemdinli - Şemdinli Malmüdürlüğü",
    "HAKKARİ/Derecik - Derecik Malmüdürlüğü",
    "HAKKARİ/Merkez - Hakkari Vergi Dairesi Müdürlüğü",
    "HAKKARİ/Yüksekova - Yüksekova Vergi Dairesi Müdürlüğü",
    "HATAY/Altınözü - Altınözü Malmüdürlüğü",
    "HATAY/Hassa - Hassa Malmüdürlüğü",
    "HATAY/Yayladağı - Yayladağı Malmüdürlüğü",
    "HATAY/Erzin - Erzin Malmüdürlüğü",
    "HATAY/Belen - Belen Malmüdürlüğü",
    "HATAY/Kumlu - Kumlu Malmüdürlüğü",
    "HATAY/Merkez - 3 Temmuz Vergi Dairesi Müdürlüğü",
    "HATAY/İskenderun - Sahil Vergi Dairesi Müdürlüğü",
    "HATAY/Merkez - Antakya Vergi Dairesi Müdürlüğü",
    "HATAY/Dörtyol - Dörtyol Vergi Dairesi Müdürlüğü",
    "HATAY/Kırıkhan - Kırıkhan Vergi Dairesi Müdürlüğü",
    "HATAY/Reyhanlı - Reyhanlı Vergi Dairesi Müdürlüğü",
    "HATAY/Samandağ - Samandağ Vergi Dairesi Müdürlüğü",
    "HATAY/Merkez - Şükrükanatlı Vergi Dairesi Müdürlüğü",
    "HATAY/İskenderun - Akdeniz Vergi Dairesi Müdürlüğü",
    "HATAY/İskenderun - Asım Gündüz Vergi Dairesi Müdürlüğü",
    "ISPARTA/Atabey - Atabey Malmüdürlüğü",
    "ISPARTA/Gelendost - Gelendost Malmüdürlüğü",
    "ISPARTA/Keçiborlu - Keçiborlu Malmüdürlüğü",
    "ISPARTA/Senirkent - Senirkent Malmüdürlüğü",
    "ISPARTA/Sütçüler - Sütçüler Malmüdürlüğü",
    "ISPARTA/Şarkikaraağaç - Şarkikaraağaç Malmüdürlüğü",
    "ISPARTA/Uluborlu - Uluborlu Malmüdürlüğü",
    "ISPARTA/Aksu - Aksu Malmüdürlüğü",
    "ISPARTA/Gönen - Gönen Malmüdürlüğü",
    "ISPARTA/Yenişarbademli - Yenişarbademli Malmüdürlüğü",
    "ISPARTA/Merkez - Davraz Vergi Dairesi Müdürlüğü",
    "ISPARTA/Merkez - Kaymakkapı Vergi Dairesi Müdürlüğü",
    "ISPARTA/Eğirdir - Eğirdir Vergi Dairesi Müdürlüğü",
    "ISPARTA/Yalvaç - Yalvaç Vergi Dairesi Müdürlüğü",
    "MERSİN/Gülnar - Gülnar Malmüdürlüğü",
    "MERSİN/Mut - Mut Malmüdürlüğü",
    "MERSİN/Aydıncık - Aydıncık Malmüdürlüğü",
    "MERSİN/Bozyazı - Bozyazı Malmüdürlüğü",
    "MERSİN/Çamlıyayla - Çamlıyayla Malmüdürlüğü",
    "MERSİN/Erdemli - Erdemli Vergi Dairesi Müdürlüğü",
    "MERSİN/Silifke - Silifke Vergi Dairesi Müdürlüğü",
    "MERSİN/Anamur - Anamur Vergi Dairesi Müdürlüğü",
    "MERSİN/Tarsus - Kızılmurat Vergi Dairesi Müdürlüğü",
    "MERSİN/Tarsus - Şehitkerim Vergi Dairesi Müdürlüğü",
    "MERSİN/Merkez - İstiklâl Vergi Dairesi Müdürlüğü",
    "MERSİN/Merkez - Uray Vergi Dairesi Müdürlüğü",
    "MERSİN/Merkez - Liman Vergi Dairesi Müdürlüğü",
    "MERSİN/Merkez - Toros Vergi Dairesi Müdürlüğü",
    "MERSİN/Merkez - Mersin İhtisas Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez- (56) - Silivri Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez- (56) - Büyükçekmece Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez- (56) - Şile Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Haliç İhtisas Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Vatan İhtisas Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Çamlıca İhtisas Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Alemdağ Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Yenikapı Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez Başkanlık - Büyük Mükellefler Vergi Dairesi Başkanlığı (*)",
    "İSTANBUL/Merkez - Boğaziçi Kurumlar Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Marmara Kurumlar Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Davutpaşa Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Esenler Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Fatih Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Küçükköy Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Merter Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Sultanbeyli Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Anadolu Kurumlar Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Tuzla Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Kozyatağı Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Maslak Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Zincirlikuyu Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - İkitelli Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Beşiktaş Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Ümraniye Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Yeditepe Veraset ve Harçlar Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Kasımpaşa Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Erenköy Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Hisar Veraset ve Harçlar Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Tuna Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Rıhtım Veraset ve Harçlar Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Güngören Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Kocasinan Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Güneşli Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Küçükyalı Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Pendik Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Bayrampaşa Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Beyazıt Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Beyoğlu Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Gaziosmanpaşa Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Göztepe Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Hocapaşa Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Kadıköy Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Kocamustafapaşa Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Mecidiyeköy Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Şişli Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Üsküdar Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Halkalı Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Kağıthane Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Zeytinburnu Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Beykoz Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Sarıyer Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Bakırköy Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Kartal Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Nakil Vasıtaları Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Sarıgazi Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Atışalanı Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Yakacık Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Yenibosna Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Avcılar Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez- (56) - Adalar Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Küçükçekmece Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Beylikdüzü Vergi Dairesi Müdürlüğü",
    "İSTANBUL/Merkez - Esenyurt Vergi Dairesi Müdürlüğü",
    "İZMİR/Dikili - Dikili Malmüdürlüğü",
    "İZMİR/Merkez- (56) - Foça Malmüdürlüğü",
    "İZMİR/Karaburun - Karaburun Malmüdürlüğü",
    "İZMİR/Merkez- (56) - Seferihisar Malmüdürlüğü",
    "İZMİR/Beydağ - Beydağ Malmüdürlüğü",
    "İZMİR/Bayındır - Bayındır Vergi Dairesi Müdürlüğü",
    "İZMİR/Bergama - Bergama Vergi Dairesi Müdürlüğü",
    "İZMİR/Merkez- (56) - Menemen Vergi Dairesi Müdürlüğü",
    "İZMİR/Ödemiş - Ödemiş Vergi Dairesi Müdürlüğü",
    "İZMİR/Tire - Tire Vergi Dairesi Müdürlüğü",
    "İZMİR/Merkez- (56) - Torbalı Vergi Dairesi Müdürlüğü",
    "İZMİR/Merkez- (56) - Kemalpaşa Vergi Dairesi Müdürlüğü",
    "İZMİR/Merkez- (56) - Urla Vergi Dairesi Müdürlüğü",
    "İZMİR/Selçuk - Selçuk Vergi Dairesi Müdürlüğü",
    "İZMİR/Kınık - Kınık Vergi Dairesi Müdürlüğü",
    "İZMİR/Kiraz - Kiraz Vergi Dairesi Müdürlüğü",
    "İZMİR/Çeşme - Çeşme Vergi Dairesi Müdürlüğü",
    "İZMİR/Merkez- (56) - Aliağa Vergi Dairesi Müdürlüğü",
    "İZMİR/Merkez- (56) - Menderes Vergi Dairesi Müdürlüğü",
    "İZMİR/Merkez - İzmir İhtisas Vergi Dairesi Müdürlüğü",
    "İZMİR/Merkez - 9 Eylül Vergi Dairesi Müdürlüğü",
    "İZMİR/Merkez - Yamanlar Vergi Dairesi Müdürlüğü",
    "İZMİR/Merkez - Belkahve Vergi Dairesi Müdürlüğü",
    "İZMİR/Merkez - Karşıyaka Vergi Dairesi Müdürlüğü",
    "İZMİR/Merkez - Kemeraltı Vergi Dairesi Müdürlüğü",
    "İZMİR/Merkez - Konak Vergi Dairesi Müdürlüğü",
    "İZMİR/Merkez - Kordon Vergi Dairesi Müdürlüğü",
    "İZMİR/Merkez - Şirinyer Vergi Dairesi Müdürlüğü",
    "İZMİR/Merkez - Kadifekale Vergi Dairesi Müdürlüğü",
    "İZMİR/Merkez - Taşıtlar Vergi Dairesi Müdürlüğü",
    "İZMİR/Merkez - Hasan Tahsin Vergi Dairesi Müdürlüğü",
    "İZMİR/Merkez - Bornova Vergi Dairesi Müdürlüğü",
    "İZMİR/Merkez - Balçova Vergi Dairesi Müdürlüğü",
    "İZMİR/Merkez - Gaziemir Vergi Dairesi Müdürlüğü",
    "İZMİR/Merkez - Ege Vergi Dairesi Müdürlüğü",
    "İZMİR/Merkez - Çiğli Vergi Dairesi Müdürlüğü",
    "İZMİR/Merkez - Çakabey İhtisas Vergi Dairesi Müdürlüğü",
    "KARS/Arpaçay - Arpaçay Malmüdürlüğü",
    "KARS/Digor - Digor Malmüdürlüğü",
    "KARS/Kağızman - Kağızman Malmüdürlüğü",
    "KARS/Sarıkamış - Sarıkamış Malmüdürlüğü",
    "KARS/Selim - Selim Malmüdürlüğü",
    "KARS/Susuz - Susuz Malmüdürlüğü",
    "KARS/Akyaka - Akyaka Malmüdürlüğü",
    "KARS/Merkez - Kars Vergi Dairesi Müdürlüğü",
    "KASTAMONU/Araç - Araç Malmüdürlüğü",
    "KASTAMONU/Azdavay - Azdavay Malmüdürlüğü",
    "KASTAMONU/Bozkurt - Bozkurt Malmüdürlüğü",
    "KASTAMONU/Cide - Cide Malmüdürlüğü",
    "KASTAMONU/Çatalzeytin - Çatalzeytin Malmüdürlüğü",
    "KASTAMONU/Daday - Daday Malmüdürlüğü",
    "KASTAMONU/Devrekani - Devrekani Malmüdürlüğü",
    "KASTAMONU/İnebolu - İnebolu Malmüdürlüğü",
    "KASTAMONU/Küre - Küre Malmüdürlüğü",
    "KASTAMONU/Abana - Abana Malmüdürlüğü",
    "KASTAMONU/İhsangazi - İhsangazi Malmüdürlüğü",
    "KASTAMONU/Pınarbaşı - Pınarbaşı Malmüdürlüğü",
    "KASTAMONU/Şenpazar - Şenpazar Malmüdürlüğü",
    "KASTAMONU/Ağlı - Ağlı Malmüdürlüğü",
    "KASTAMONU/Doğanyurt - Doğanyurt Malmüdürlüğü",
    "KASTAMONU/Hanönü - Hanönü Malmüdürlüğü",
    "KASTAMONU/Seydiler - Seydiler Malmüdürlüğü",
    "KASTAMONU/Merkez - Kastamonu Vergi Dairesi Müdürlüğü",
    "KASTAMONU/Tosya - Tosya Vergi Dairesi Müdürlüğü",
    "KASTAMONU/Taşköprü - Taşköprü Vergi Dairesi Müdürlüğü",
    "KAYSERİ/Felahiye - Felahiye Malmüdürlüğü",
    "KAYSERİ/İncesu - İncesu Malmüdürlüğü",
    "KAYSERİ/Sarıoğlan - Sarıoğlan Malmüdürlüğü",
    "KAYSERİ/Sarız - Sarız Malmüdürlüğü",
    "KAYSERİ/Tomarza - Tomarza Malmüdürlüğü",
    "KAYSERİ/Yahyalı - Yahyalı Malmüdürlüğü",
    "KAYSERİ/Yeşilhisar - Yeşilhisar Malmüdürlüğü",
    "KAYSERİ/Akkışla - Akkışla Malmüdürlüğü",
    "KAYSERİ/Merkez- (56) - Hacılar Malmüdürlüğü",
    "KAYSERİ/Özvatan - Özvatan Malmüdürlüğü",
    "KAYSERİ/Develi - Develi Vergi Dairesi Müdürlüğü",
    "KAYSERİ/Pınarbaşı - Pınarbaşı Vergi Dairesi Müdürlüğü",
    "KAYSERİ/Bünyan - Bünyan Vergi Dairesi Müdürlüğü",
    "KAYSERİ/Merkez - Kayseri İhtisas Vergi Dairesi Müdürlüğü",
    "KAYSERİ/Merkez - Mimar Sinan Vergi Dairesi Müdürlüğü",
    "KAYSERİ/Merkez - Erciyes Vergi Dairesi Müdürlüğü",
    "KAYSERİ/Merkez - Kaleönü Vergi Dairesi Müdürlüğü",
    "KAYSERİ/Merkez - Gevher Nesibe Vergi Dairesi Müdürlüğü",
    "KIRKLARELİ/Demirköy - Demirköy Malmüdürlüğü",
    "KIRKLARELİ/Kofçaz - Kofçaz Malmüdürlüğü",
    "KIRKLARELİ/Pehlivanköy - Pehlivanköy Malmüdürlüğü",
    "KIRKLARELİ/Pınarhisar - Pınarhisar Malmüdürlüğü",
    "KIRKLARELİ/Vize - Vize Malmüdürlüğü",
    "KIRKLARELİ/Merkez - Kırklareli Vergi Dairesi Müdürlüğü",
    "KIRKLARELİ/Lüleburgaz - Lüleburgaz Vergi Dairesi Müdürlüğü",
    "KIRKLARELİ/Babaeski - Babaeski Vergi Dairesi Müdürlüğü",
    "KIRŞEHİR/Çiçekdağı - Çiçekdağı Malmüdürlüğü",
    "KIRŞEHİR/Mucur - Mucur Malmüdürlüğü",
    "KIRŞEHİR/Akpınar - Akpınar Malmüdürlüğü",
    "KIRŞEHİR/Akçakent - Akçakent Malmüdürlüğü",
    "KIRŞEHİR/Boztepe - Boztepe Malmüdürlüğü",
    "KIRŞEHİR/Merkez - Kırşehir Vergi Dairesi Müdürlüğü",
    "KIRŞEHİR/Kaman - Kaman Vergi Dairesi Müdürlüğü",
    "KOCAELİ/Merkez- (56) - Kandıra Malmüdürlüğü",
    "KOCAELİ/Merkez- (56) - Uluçınar Vergi Dairesi Müdürlüğü",
    "KOCAELİ/Merkez- (56) - İlyasbey Vergi Dairesi Müdürlüğü",
    "KOCAELİ/Merkez- (56) - Gölcük Vergi Dairesi Müdürlüğü",
    "KOCAELİ/Merkez- (56) - Karamürsel Vergi Dairesi Müdürlüğü",
    "KOCAELİ/Merkez- (56) - Körfez Vergi Dairesi Müdürlüğü",
    "KOCAELİ/Merkez- (56) - Derince Vergi Dairesi Müdürlüğü",
    "KOCAELİ/Merkez - Kocaeli İhtisas Vergi Dairesi Müdürlüğü",
    "KOCAELİ/Merkez - Tepecik Vergi Dairesi Müdürlüğü",
    "KOCAELİ/Merkez - Alemdar Vergi Dairesi Müdürlüğü",
    "KOCAELİ/Merkez- (56) - Gebze İhtisas Vergi Dairesi Müdürlüğü",
    "KOCAELİ/Merkez - Acısu Vergi Dairesi Müdürlüğü",
    "KONYA/Bozkır - Bozkır Malmüdürlüğü",
    "KONYA/Doğanhisar - Doğanhisar Malmüdürlüğü",
    "KONYA/Hadim - Hadim Malmüdürlüğü",
    "KONYA/Kadınhanı - Kadınhanı Malmüdürlüğü",
    "KONYA/Sarayönü - Sarayönü Malmüdürlüğü",
    "KONYA/Yunak - Yunak Malmüdürlüğü",
    "KONYA/Akören - Akören Malmüdürlüğü",
    "KONYA/Altınekin - Altınekin Malmüdürlüğü",
    "KONYA/Derebucak - Derebucak Malmüdürlüğü",
    "KONYA/Hüyük - Hüyük Malmüdürlüğü",
    "KONYA/Taşkent - Taşkent Malmüdürlüğü",
    "KONYA/Ahırlı - Ahırlı Malmüdürlüğü",
    "KONYA/Çeltik - Çeltik Malmüdürlüğü",
    "KONYA/Derbent - Derbent Malmüdürlüğü",
    "KONYA/Emirgazi - Emirgazi Malmüdürlüğü",
    "KONYA/Güneysınır - Güneysınır Malmüdürlüğü",
    "KONYA/Halkapınar - Halkapınar Malmüdürlüğü",
    "KONYA/Tuzlukçu - Tuzlukçu Malmüdürlüğü",
    "KONYA/Yalıhüyük - Yalıhüyük Malmüdürlüğü",
    "KONYA/Akşehir - Akşehir Vergi Dairesi Müdürlüğü",
    "KONYA/Ereğli - Ereğli Vergi Dairesi Müdürlüğü",
    "KONYA/Beyşehir - Beyşehir Vergi Dairesi Müdürlüğü",
    "KONYA/Cihanbeyli - Cihanbeyli Vergi Dairesi Müdürlüğü",
    "KONYA/Çumra - Çumra Vergi Dairesi Müdürlüğü",
    "KONYA/Seydişehir - Seydişehir Vergi Dairesi Müdürlüğü",
    "KONYA/Ilgın - Ilgın Vergi Dairesi Müdürlüğü",
    "KONYA/Kulu - Kulu Vergi Dairesi Müdürlüğü",
    "KONYA/Karapınar - Karapınar Vergi Dairesi Müdürlüğü",
    "KONYA/Merkez - Konya İhtisas Vergi Dairesi Müdürlüğü",
    "KONYA/Merkez - Selçuk Vergi Dairesi Müdürlüğü",
    "KONYA/Merkez - Mevlana Vergi Dairesi Müdürlüğü",
    "KONYA/Merkez - Meram Vergi Dairesi Müdürlüğü",
    "KONYA/Merkez - Alaaddin Vergi Dairesi Müdürlüğü",
    "KÜTAHYA/Altıntaş - Altıntaş Malmüdürlüğü",
    "KÜTAHYA/Domaniç - Domaniç Malmüdürlüğü",
    "KÜTAHYA/Aslanapa - Aslanapa Malmüdürlüğü",
    "KÜTAHYA/Dumlupınar - Dumlupınar Malmüdürlüğü",
    "KÜTAHYA/Hisarcık - Hisarcık Malmüdürlüğü",
    "KÜTAHYA/Şaphane - Şaphane Malmüdürlüğü",
    "KÜTAHYA/Çavdarhisar - Çavdarhisar Malmüdürlüğü",
    "KÜTAHYA/Pazarlar - Pazarlar Malmüdürlüğü",
    "KÜTAHYA/Merkez - 30 Ağustos Vergi Dairesi Müdürlüğü",
    "KÜTAHYA/Gediz - Gediz Vergi Dairesi Müdürlüğü",
    "KÜTAHYA/Simav - Simav Vergi Dairesi Müdürlüğü",
    "KÜTAHYA/Tavşanlı - Tavşanlı Vergi Dairesi Müdürlüğü",
    "KÜTAHYA/Emet - Emet Vergi Dairesi Müdürlüğü",
    "KÜTAHYA/Merkez - Çinili Vergi Dairesi Müdürlüğü",
    "MALATYA/Akçadağ - Akçadağ Malmüdürlüğü",
    "MALATYA/Arapgir - Arapgir Malmüdürlüğü",
    "MALATYA/Arguvan - Arguvan Malmüdürlüğü",
    "MALATYA/Darende - Darende Malmüdürlüğü",
    "MALATYA/Doğanşehir - Doğanşehir Malmüdürlüğü",
    "MALATYA/Hekimhan - Hekimhan Malmüdürlüğü",
    "MALATYA/Pütürge - Pütürge Malmüdürlüğü",
    "MALATYA/Yeşilyurt - Yeşilyurt Malmüdürlüğü",
    "MALATYA/Battalgazi - Battalgazi Malmüdürlüğü",
    "MALATYA/Doğanyol - Doğanyol Malmüdürlüğü",
    "MALATYA/Kale - Kale Malmüdürlüğü",
    "MALATYA/Kuluncak - Kuluncak Malmüdürlüğü",
    "MALATYA/Yazıhan - Yazıhan Malmüdürlüğü",
    "MALATYA/Merkez - Fırat Vergi Dairesi Müdürlüğü",
    "MALATYA/Merkez - Beydağı Vergi Dairesi Müdürlüğü",
    "MANİSA/Selendi - Selendi Malmüdürlüğü",
    "MANİSA/Ahmetli - Ahmetli Malmüdürlüğü",
    "MANİSA/Gölmarmara - Gölmarmara Malmüdürlüğü",
    "MANİSA/Köprübaşı - Köprübaşı Malmüdürlüğü",
    "MANİSA/Akhisar - Akhisar Vergi Dairesi Müdürlüğü",
    "MANİSA/Alaşehir - Alaşehir Vergi Dairesi Müdürlüğü",
    "MANİSA/Demirci - Demirci Vergi Dairesi Müdürlüğü",
    "MANİSA/Kırkağaç - Kırkağaç Vergi Dairesi Müdürlüğü",
    "MANİSA/Salihli - Salihli Adil Oral Vergi Dairesi Müdürlüğü",
    "MANİSA/Sarıgöl - Sarıgöl Vergi Dairesi Müdürlüğü",
    "MANİSA/Saruhanlı - Saruhanlı Vergi Dairesi Müdürlüğü",
    "MANİSA/Soma - Soma Vergi Dairesi Müdürlüğü",
    "MANİSA/Turgutlu - Turgutlu Vergi Dairesi Müdürlüğü",
    "MANİSA/Gördes - Gördes Vergi Dairesi Müdürlüğü",
    "MANİSA/Kula - Kula Vergi Dairesi Müdürlüğü",
    "MANİSA/Merkez - Manisa İhtisas Vergi Dairesi Müdürlüğü",
    "MANİSA/Merkez - Şehit Cihan Güneş Vergi Dairesi Müdürlüğü",
    "MANİSA/Merkez - Mesir Vergi Dairesi Müdürlüğü",
    "KAHRAMANMARAŞ/Andırın - Andırın Malmüdürlüğü",
    "KAHRAMANMARAŞ/Göksun - Göksun Malmüdürlüğü",
    "KAHRAMANMARAŞ/Türkoğlu - Türkoğlu Malmüdürlüğü",
    "KAHRAMANMARAŞ/Çağlayancerit - Çağlayancerit Malmüdürlüğü",
    "KAHRAMANMARAŞ/Ekinözü - Ekinözü Malmüdürlüğü",
    "KAHRAMANMARAŞ/Nurhak - Nurhak Malmüdürlüğü",
    "KAHRAMANMARAŞ/Merkez - Aslanbey Vergi Dairesi Müdürlüğü",
    "KAHRAMANMARAŞ/Elbistan - Elbistan Vergi Dairesi Müdürlüğü",
    "KAHRAMANMARAŞ/Afşin - Afşin Vergi Dairesi Müdürlüğü",
    "KAHRAMANMARAŞ/Pazarcık - Pazarcık Vergi Dairesi Müdürlüğü",
    "KAHRAMANMARAŞ/Merkez - Aksu Vergi Dairesi Müdürlüğü",
    "MARDİN/Derik - Derik Malmüdürlüğü",
    "MARDİN/Mazıdağı - Mazıdağı Malmüdürlüğü",
    "MARDİN/Midyat - Midyat Malmüdürlüğü",
    "MARDİN/Ömerli - Ömerli Malmüdürlüğü",
    "MARDİN/Savur - Savur Malmüdürlüğü",
    "MARDİN/Dargeçit - Dargeçit Malmüdürlüğü",
    "MARDİN/Yeşilli - Yeşilli Malmüdürlüğü",
    "MARDİN/Merkez - Mardin Vergi Dairesi Müdürlüğü",
    "MARDİN/Kızıltepe - Kızıltepe Vergi Dairesi Müdürlüğü",
    "MARDİN/Nusaybin - Nusaybin Vergi Dairesi Müdürlüğü",
    "MUĞLA/Datça - Datça Malmüdürlüğü",
    "MUĞLA/Ula - Ula Malmüdürlüğü",
    "MUĞLA/Dalaman - Dalaman Malmüdürlüğü",
    "MUĞLA/Ortaca - Ortaca Malmüdürlüğü",
    "MUĞLA/Kavaklıdere - Kavaklıdere Malmüdürlüğü",
    "MUĞLA/Seydiemer - Seydikemer Malmüdürlüğü",
    "MUĞLA/Merkez - Muğla Vergi Dairesi Müdürlüğü",
    "MUĞLA/Bodrum - Bodrum Vergi Dairesi Müdürlüğü",
    "MUĞLA/Fethiye - Fethiye Vergi Dairesi Müdürlüğü",
    "MUĞLA/Köyceğiz - Köyceğiz Vergi Dairesi Müdürlüğü",
    "MUĞLA/Milas - Milas Vergi Dairesi Müdürlüğü",
    "MUĞLA/Marmaris - Marmaris Vergi Dairesi Müdürlüğü",
    "MUĞLA/Yatağan - Yatağan Vergi Dairesi Müdürlüğü",
    "MUŞ/Bulanık - Bulanık Malmüdürlüğü",
    "MUŞ/Malazgirt - Malazgirt Malmüdürlüğü",
    "MUŞ/Varto - Varto Malmüdürlüğü",
    "MUŞ/Hasköy - Hasköy Malmüdürlüğü",
    "MUŞ/Korkut - Korkut Malmüdürlüğü",
    "MUŞ/Merkez - Muş Vergi Dairesi Müdürlüğü",
    "NEVŞEHİR/Avanos - Avanos Malmüdürlüğü",
    "NEVŞEHİR/Derinkuyu - Derinkuyu Malmüdürlüğü",
    "NEVŞEHİR/Gülşehir - Gülşehir Malmüdürlüğü",
    "NEVŞEHİR/Hacıbektaş - Hacıbektaş Malmüdürlüğü",
    "NEVŞEHİR/Kozaklı - Kozaklı Malmüdürlüğü",
    "NEVŞEHİR/Ürgüp - Ürgüp Malmüdürlüğü",
    "NEVŞEHİR/Acıgöl - Acıgöl Malmüdürlüğü",
    "NEVŞEHİR/Merkez - Nevşehir Vergi Dairesi Müdürlüğü",
    "NİĞDE/Çamardı - Çamardı Malmüdürlüğü",
    "NİĞDE/Ulukışla - Ulukışla Malmüdürlüğü",
    "NİĞDE/Altunhisar - Altunhisar Malmüdürlüğü",
    "NİĞDE/Çiftlik - Çiftlik Malmüdürlüğü",
    "NİĞDE/Merkez - Niğde Vergi Dairesi Müdürlüğü",
    "NİĞDE/Bor - Bor Vergi Dairesi Müdürlüğü",
    "ORDU/Akkuş - Akkuş Malmüdürlüğü",
    "ORDU/Aybastı - Aybastı Malmüdürlüğü",
    "ORDU/Gölköy - Gölköy Malmüdürlüğü",
    "ORDU/Korgan - Korgan Malmüdürlüğü",
    "ORDU/Kumru - Kumru Malmüdürlüğü",
    "ORDU/Mesudiye - Mesudiye Malmüdürlüğü",
    "ORDU/Perşembe - Perşembe Malmüdürlüğü",
    "ORDU/Ulubey - Ulubey Malmüdürlüğü",
    "ORDU/Gülyalı - Gülyalı Malmüdürlüğü",
    "ORDU/Gürgentepe - Gürgentepe Malmüdürlüğü",
    "ORDU/Çamaş - Çamaş Malmüdürlüğü",
    "ORDU/Çatalpınar - Çatalpınar Malmüdürlüğü",
    "ORDU/Çaybaşı - Çaybaşı Malmüdürlüğü",
    "ORDU/İkizce - İkizce Malmüdürlüğü",
    "ORDU/Kabadüz - Kabadüz Malmüdürlüğü",
    "ORDU/Kabataş - Kabataş Malmüdürlüğü",
    "ORDU/Merkez - Boztepe Vergi Dairesi Müdürlüğü",
    "ORDU/Merkez - Köprübaşı Vergi Dairesi Müdürlüğü",
    "ORDU/Fatsa - Fatsa Vergi Dairesi Müdürlüğü",
    "ORDU/Ünye - Ünye Vergi Dairesi Müdürlüğü",
    "RİZE/Çamlıhemşin - Çamlıhemşin Malmüdürlüğü",
    "RİZE/Fındıklı - Fındıklı Malmüdürlüğü",
    "RİZE/İkizdere - İkizdere Malmüdürlüğü",
    "RİZE/Kalkandere - Kalkandere Malmüdürlüğü",
    "RİZE/Güneysu - Güneysu Malmüdürlüğü",
    "RİZE/Derepazarı - Derepazarı Malmüdürlüğü",
    "RİZE/Hemşin - Hemşin Malmüdürlüğü",
    "RİZE/İyidere - İyidere Malmüdürlüğü",
    "RİZE/Merkez - Kaçkar Vergi Dairesi Müdürlüğü",
    "RİZE/Merkez - Yeşilçay Vergi Dairesi Müdürlüğü",
    "RİZE/Çayeli - Çayeli Vergi Dairesi Müdürlüğü",
    "RİZE/Pazar - Pazar Vergi Dairesi Müdürlüğü",
    "RİZE/Ardeşen - Ardeşen Vergi Dairesi Müdürlüğü",
    "SAKARYA/Kaynarca - Kaynarca Malmüdürlüğü",
    "SAKARYA/Kocaali - Kocaali Malmüdürlüğü",
    "SAKARYA/Pamukova - Pamukova Malmüdürlüğü",
    "SAKARYA/Taraklı - Taraklı Malmüdürlüğü",
    "SAKARYA/Merkez- (56) - Karapürçek Malmüdürlüğü",
    "SAKARYA/Merkez- (56) - Akyazı Vergi Dairesi Müdürlüğü",
    "SAKARYA/Geyve - Geyve Vergi Dairesi Müdürlüğü",
    "SAKARYA/Merkez- (56) - Hendek Vergi Dairesi Müdürlüğü",
    "SAKARYA/Karasu - Karasu Vergi Dairesi Müdürlüğü",
    "SAKARYA/Merkez - Sakarya İhtisas Vergi Dairesi Müdürlüğü",
    "SAKARYA/Merkez - Gümrükönü Vergi Dairesi Müdürlüğü",
    "SAKARYA/Merkez - Ali Fuat Cebesoy Vergi Dairesi Müdürlüğü",
    "SAKARYA/Merkez- (56) - Sapanca Vergi Dairesi Müdürlüğü",
    "SAMSUN/Alaçam - Alaçam Malmüdürlüğü",
    "SAMSUN/Kavak - Kavak Malmüdürlüğü",
    "SAMSUN/Ladik - Ladik Malmüdürlüğü",
    "SAMSUN/Vezirköprü - Vezirköprü Malmüdürlüğü",
    "SAMSUN/Asarcık - Asarcık Malmüdürlüğü",
    "SAMSUN/Ondokuz Mayıs - Ondokuz Mayıs Malmüdürlüğü",
    "SAMSUN/Salıpazarı - Salıpazarı Malmüdürlüğü",
    "SAMSUN/Merkez- (56) - Tekkeköy Malmüdürlüğü",
    "SAMSUN/Ayvacık - Ayvacık Malmüdürlüğü",
    "SAMSUN/Yakakent - Yakakent Malmüdürlüğü",
    "SAMSUN/Bafra - Bafra Vergi Dairesi Müdürlüğü",
    "SAMSUN/Çarşamba - Çarşamba Vergi Dairesi Müdürlüğü",
    "SAMSUN/Terme - Terme Vergi Dairesi Müdürlüğü",
    "SAMSUN/Havza - Havza Vergi Dairesi Müdürlüğü",
    "SAMSUN/Merkez - 9 Mayıs Vergi Dairesi Müdürlüğü",
    "SAMSUN/Merkez - Gaziler Vergi Dairesi Müdürlüğü",
    "SAMSUN/Merkez - Zafer Vergi Dairesi Müdürlüğü",
    "SİİRT/Baykan - Baykan Malmüdürlüğü",
    "SİİRT/Eruh - Eruh Malmüdürlüğü",
    "SİİRT/Kurtalan - Kurtalan Malmüdürlüğü",
    "SİİRT/Pervari - Pervari Malmüdürlüğü",
    "SİİRT/Şirvan - Şirvan Malmüdürlüğü",
    "SİİRT/Merkez - Siirt Vergi Dairesi Müdürlüğü",
    "SİNOP/Ayancık - Ayancık Malmüdürlüğü",
    "SİNOP/Durağan - Durağan Malmüdürlüğü",
    "SİNOP/Erfelek - Erfelek Malmüdürlüğü",
    "SİNOP/Gerze - Gerze Malmüdürlüğü",
    "SİNOP/Türkeli - Türkeli Malmüdürlüğü",
    "SİNOP/Dikmen - Dikmen Malmüdürlüğü",
    "SİNOP/Saraydüzü - Saraydüzü Malmüdürlüğü",
    "SİNOP/Merkez - Sinop Vergi Dairesi Müdürlüğü",
    "SİNOP/Boyabat - Boyabat Vergi Dairesi Müdürlüğü",
    "SİVAS/Divriği - Divriği Malmüdürlüğü",
    "SİVAS/Gemerek - Gemerek Malmüdürlüğü",
    "SİVAS/Gürün - Gürün Malmüdürlüğü",
    "SİVAS/Hafik - Hafik Malmüdürlüğü",
    "SİVAS/İmranlı - İmranlı Malmüdürlüğü",
    "SİVAS/Kangal - Kangal Malmüdürlüğü",
    "SİVAS/Koyulhisar - Koyulhisar Malmüdürlüğü",
    "SİVAS/Suşehri - Suşehri Malmüdürlüğü",
    "SİVAS/Yıldızeli - Yıldızeli Malmüdürlüğü",
    "SİVAS/Zara - Zara Malmüdürlüğü",
    "SİVAS/Akıncılar - Akıncılar Malmüdürlüğü",
    "SİVAS/Altınyayla - Altınyayla Malmüdürlüğü",
    "SİVAS/Doğanşar - Doğanşar Malmüdürlüğü",
    "SİVAS/Gölova - Gölova Malmüdürlüğü",
    "SİVAS/Ulaş - Ulaş Malmüdürlüğü",
    "SİVAS/Merkez - Kale Vergi Dairesi Müdürlüğü",
    "SİVAS/Şarkışla - Şarkışla Vergi Dairesi Müdürlüğü",
    "SİVAS/Merkez - Site Vergi Dairesi Müdürlüğü",
    "TEKİRDAĞ/Saray - Saray Malmüdürlüğü",
    "TEKİRDAĞ/Marmaraereğlisi - Marmaraereğlisi Malmüdürlüğü",
    "TEKİRDAĞ/Merkez - Süleymanpaşa Vergi Dairesi Müdürlüğü",
    "TEKİRDAĞ/Çorlu - Çorlu İhtisas Vergi Dairesi Müdürlüğü",
    "TEKİRDAĞ/Merkez - Namık Kemal Vergi Dairesi Müdürlüğü",
    "TEKİRDAĞ/Çerkezköy - Çerkezköy Vergi Dairesi Müdürlüğü",
    "TEKİRDAĞ/Çorlu - Çorlu Vergi Dairesi Müdürlüğü",
    "TEKİRDAĞ/Hayrabolu - Hayrabolu Vergi Dairesi Müdürlüğü",
    "TEKİRDAĞ/Malkara - Malkara Vergi Dairesi Müdürlüğü",
    "TEKİRDAĞ/Muratlı - Muratlı Vergi Dairesi Müdürlüğü",
    "TEKİRDAĞ/Şarköy - Şarköy Vergi Dairesi Müdürlüğü",
    "TEKİRDAĞ/Kapaklı - Kapaklı Vergi Dairesi Müdürlüğü",
    "TOKAT/Almus - Almus Malmüdürlüğü",
    "TOKAT/Artova - Artova Malmüdürlüğü",
    "TOKAT/Reşadiye - Reşadiye Malmüdürlüğü",
    "TOKAT/Pazar - Pazar Malmüdürlüğü",
    "TOKAT/Yeşilyurt - Yeşilyurt Malmüdürlüğü",
    "TOKAT/Başçiftlik - Başçiftlik Malmüdürlüğü",
    "TOKAT/Sulusaray - Sulusaray Malmüdürlüğü",
    "TOKAT/Merkez - Tokat Vergi Dairesi Müdürlüğü",
    "TOKAT/Erbaa - Erbaa Vergi Dairesi Müdürlüğü",
    "TOKAT/Niksar - Niksar Vergi Dairesi Müdürlüğü",
    "TOKAT/Turhal - Turhal Vergi Dairesi Müdürlüğü",
    "TOKAT/Zile - Zile Vergi Dairesi Müdürlüğü",
    "TRABZON/Araklı - Araklı Malmüdürlüğü",
    "TRABZON/Arsin - Arsin Malmüdürlüğü",
    "TRABZON/Çaykara - Çaykara Malmüdürlüğü",
    "TRABZON/Maçka - Maçka Malmüdürlüğü",
    "TRABZON/Sürmene - Sürmene Malmüdürlüğü",
    "TRABZON/Tonya - Tonya Malmüdürlüğü",
    "TRABZON/Yomra - Yomra Malmüdürlüğü",
    "TRABZON/Beşikdüzü - Beşikdüzü Malmüdürlüğü",
    "TRABZON/Şalpazarı - Şalpazarı Malmüdürlüğü",
    "TRABZON/Çarşıbaşı - Çarşıbaşı Malmüdürlüğü",
    "TRABZON/Dernekpazarı - Dernekpazarı Malmüdürlüğü",
    "TRABZON/Düzköy - Düzköy Malmüdürlüğü",
    "TRABZON/Hayrat - Hayrat Malmüdürlüğü",
    "TRABZON/Köprübaşı - Köprübaşı Malmüdürlüğü",
    "TRABZON/Merkez - Hızırbey Vergi Dairesi Müdürlüğü",
    "TRABZON/Akçaabat - Akçaabat Vergi Dairesi Müdürlüğü",
    "TRABZON/Of - Of Vergi Dairesi Müdürlüğü",
    "TRABZON/Vakfıkebir - Vakfıkebir Vergi Dairesi Müdürlüğü",
    "TRABZON/Merkez - Karadeniz Vergi Dairesi Müdürlüğü",
    "TUNCELİ/Çemişgezek - Çemişgezek Malmüdürlüğü",
    "TUNCELİ/Hozat - Hozat Malmüdürlüğü",
    "TUNCELİ/Mazgirt - Mazgirt Malmüdürlüğü",
    "TUNCELİ/Nazimiye - Nazimiye Malmüdürlüğü",
    "TUNCELİ/Ovacık - Ovacık Malmüdürlüğü",
    "TUNCELİ/Pertek - Pertek Malmüdürlüğü",
    "TUNCELİ/Pülümür - Pülümür Malmüdürlüğü",
    "TUNCELİ/Merkez - Tunceli Vergi Dairesi Müdürlüğü",
    "ŞANLIURFA/Akçakale - Akçakale Malmüdürlüğü",
    "ŞANLIURFA/Bozova - Bozova Malmüdürlüğü",
    "ŞANLIURFA/Halfeti - Halfeti Malmüdürlüğü",
    "ŞANLIURFA/Hilvan - Hilvan Malmüdürlüğü",
    "ŞANLIURFA/Ceylanpınar - Ceylanpınar Malmüdürlüğü",
    "ŞANLIURFA/Harran - Harran Malmüdürlüğü",
    "ŞANLIURFA/Merkez - Şehitlik Vergi Dairesi Müdürlüğü",
    "ŞANLIURFA/Siverek - Siverek Vergi Dairesi Müdürlüğü",
    "ŞANLIURFA/Viranşehir - Viranşehir Vergi Dairesi Müdürlüğü",
    "ŞANLIURFA/Birecik - Birecik Vergi Dairesi Müdürlüğü",
    "ŞANLIURFA/Suruç - Suruç Vergi Dairesi Müdürlüğü",
    "ŞANLIURFA/Merkez - Topçu Meydanı Vergi Dairesi Müdürlüğü",
    "ŞANLIURFA/Merkez - Göbeklitepe Vergi Dairesi Müdürlüğü",
    "UŞAK/Karahallı - Karahallı Malmüdürlüğü",
    "UŞAK/Ulubey - Ulubey Malmüdürlüğü",
    "UŞAK/Sivaslı - Sivaslı Malmüdürlüğü",
    "UŞAK/Merkez - Uşak Vergi Dairesi Müdürlüğü",
    "UŞAK/Banaz - Banaz Vergi Dairesi Müdürlüğü",
    "UŞAK/Eşme - Eşme Vergi Dairesi Müdürlüğü",
    "VAN/Başkale - Başkale Malmüdürlüğü",
    "VAN/Çatak - Çatak Malmüdürlüğü",
    "VAN/Gevaş - Gevaş Malmüdürlüğü",
    "VAN/Gürpınar - Gürpınar Malmüdürlüğü",
    "VAN/Muradiye - Muradiye Malmüdürlüğü",
    "VAN/Özalp - Özalp Malmüdürlüğü",
    "VAN/Bahçesaray - Bahçesaray Malmüdürlüğü",
    "VAN/Çaldıran - Çaldıran Malmüdürlüğü",
    "VAN/Edremit - Edremit Malmüdürlüğü",
    "VAN/Saray - Saray Malmüdürlüğü",
    "VAN/Erciş - Erciş Vergi Dairesi Müdürlüğü",
    "VAN/Merkez - Van Vergi Dairesi Müdürlüğü",
    "YOZGAT/Akdağmadeni - Akdağmadeni Malmüdürlüğü",
    "YOZGAT/Çayıralan - Çayıralan Malmüdürlüğü",
    "YOZGAT/Çekerek - Çekerek Malmüdürlüğü",
    "YOZGAT/Sarıkaya - Sarıkaya Malmüdürlüğü",
    "YOZGAT/Şefaatli - Şefaatli Malmüdürlüğü",
    "YOZGAT/Aydıncık - Aydıncık Malmüdürlüğü",
    "YOZGAT/Çandır - Çandır Malmüdürlüğü",
    "YOZGAT/Kadışehri - Kadışehri Malmüdürlüğü",
    "YOZGAT/Saraykent - Saraykent Malmüdürlüğü",
    "YOZGAT/Yenifakılı - Yenifakılı Malmüdürlüğü",
    "YOZGAT/Merkez - Yozgat Vergi Dairesi Müdürlüğü",
    "YOZGAT/Boğazlıyan - Boğazlıyan Vergi Dairesi Müdürlüğü",
    "YOZGAT/Sorgun - Sorgun Vergi Dairesi Müdürlüğü",
    "YOZGAT/Yerköy - Yerköy Vergi Dairesi Müdürlüğü",
    "ZONGULDAK/Alaplı - Alaplı Malmüdürlüğü",
    "ZONGULDAK/Gökçebey - Gökçebey Malmüdürlüğü",
    "ZONGULDAK/Merkez - Uzunmehmet Vergi Dairesi Müdürlüğü",
    "ZONGULDAK/Ereğli - Ereğli Vergi Dairesi Müdürlüğü",
    "ZONGULDAK/Çaycuma - Çaycuma Vergi Dairesi Müdürlüğü",
    "ZONGULDAK/Devrek - Devrek Vergi Dairesi Müdürlüğü",
    "ZONGULDAK/Merkez - Kara Elmas Vergi Dairesi Müdürlüğü",
    "AKSARAY/Ağaçören - Ağaçören Malmüdürlüğü",
    "AKSARAY/Güzelyurt - Güzelyurt Malmüdürlüğü",
    "AKSARAY/Ortaköy - Ortaköy Malmüdürlüğü",
    "AKSARAY/Sarıyahşi - Sarıyahşi Malmüdürlüğü",
    "AKSARAY/Eskil - Eskil Malmüdürlüğü",
    "AKSARAY/Gülağaç - Gülağaç Malmüdürlüğü",
    "AKSARAY/Sultanhanı - Sultanhanı Malmüdürlüğü",
    "AKSARAY/Merkez - Aksaray Vergi Dairesi Müdürlüğü",
    "BAYBURT/Aydıntepe - Aydıntepe Malmüdürlüğü",
    "BAYBURT/Demirözü - Demirözü Malmüdürlüğü",
    "BAYBURT/Merkez - Bayburt Vergi Dairesi Müdürlüğü",
    "KARAMAN/Ayrancı - Ayrancı Malmüdürlüğü",
    "KARAMAN/Ermenek - Ermenek Malmüdürlüğü",
    "KARAMAN/Kazım Karabekir - Kazım Karabekir Malmüdürlüğü",
    "KARAMAN/Başyayla - Başyayla Malmüdürlüğü",
    "KARAMAN/Sarıveliler - Sarıveliler Malmüdürlüğü",
    "KARAMAN/Merkez - Karaman Vergi Dairesi Müdürlüğü",
    "KIRIKKALE/Delice - Delice Malmüdürlüğü",
    "KIRIKKALE/Keskin - Keskin Malmüdürlüğü",
    "KIRIKKALE/Sulakyurt - Sulakyurt Malmüdürlüğü",
    "KIRIKKALE/Balışeyh - Balışeyh Malmüdürlüğü",
    "KIRIKKALE/Çelebi - Çelebi Malmüdürlüğü",
    "KIRIKKALE/Karakeçili - Karakeçili Malmüdürlüğü",
    "KIRIKKALE/Merkez - Irmak Vergi Dairesi Müdürlüğü",
    "KIRIKKALE/Merkez - Kaletepe Vergi Dairesi Müdürlüğü",
    "BATMAN/Beşiri - Beşiri Malmüdürlüğü",
    "BATMAN/Gercüş - Gercüş Malmüdürlüğü",
    "BATMAN/Hasankeyf - Hasankeyf Malmüdürlüğü",
    "BATMAN/Kozluk - Kozluk Malmüdürlüğü",
    "BATMAN/Sason - Sason Malmüdürlüğü",
    "BATMAN/Merkez - Batman Vergi Dairesi Müdürlüğü",
    "ŞIRNAK/Beytüşşebap - Beytüşşebap Malmüdürlüğü",
    "ŞIRNAK/Güçlükonak - Güçlükonak Malmüdürlüğü",
    "ŞIRNAK/İdil - İdil Malmüdürlüğü",
    "ŞIRNAK/Uludere - Uludere Malmüdürlüğü",
    "ŞIRNAK/Merkez - Şırnak Vergi Dairesi Müdürlüğü",
    "ŞIRNAK/Cizre - Cizre Vergi Dairesi Müdürlüğü",
    "ŞIRNAK/Silopi - Silopi Vergi Dairesi Müdürlüğü",
    "BARTIN/Amasra - Amasra Malmüdürlüğü",
    "BARTIN/Kurucaşile - Kurucaşile Malmüdürlüğü",
    "BARTIN/Ulus - Ulus Malmüdürlüğü",
    "BARTIN/Merkez - Bartın Vergi Dairesi Müdürlüğü",
    "ARDAHAN/Çıldır - Çıldır Malmüdürlüğü",
    "ARDAHAN/Damal - Damal Malmüdürlüğü",
    "ARDAHAN/Göle - Göle Malmüdürlüğü",
    "ARDAHAN/Hanak - Hanak Malmüdürlüğü",
    "ARDAHAN/Posof - Posof Malmüdürlüğü",
    "ARDAHAN/Merkez - Ardahan Vergi Dairesi Müdürlüğü",
    "IĞDIR/Aralık - Aralık Malmüdürlüğü",
    "IĞDIR/Karakoyunlu - Karakoyunlu Malmüdürlüğü",
    "IĞDIR/Tuzluca - Tuzluca Malmüdürlüğü",
    "IĞDIR/Merkez - Iğdır Vergi Dairesi Müdürlüğü",
    "YALOVA/Altınova - Altınova Malmüdürlüğü",
    "YALOVA/Armutlu - Armutlu Malmüdürlüğü",
    "YALOVA/Çınarcık - Çınarcık Malmüdürlüğü",
    "YALOVA/Merkez - Yalova Vergi Dairesi Müdürlüğü",
    "KARABÜK/Eflani - Eflani Malmüdürlüğü",
    "KARABÜK/Eskipazar - Eskipazar Malmüdürlüğü",
    "KARABÜK/Ovacık - Ovacık Malmüdürlüğü",
    "KARABÜK/Yenice - Yenice Malmüdürlüğü",
    "KARABÜK/Merkez - Karabük Vergi Dairesi Müdürlüğü",
    "KARABÜK/Safranbolu - Safranbolu Vergi Dairesi Müdürlüğü",
    "KİLİS/Merkez - Kilis Vergi Dairesi Müdürlüğü",
    "OSMANİYE/Bahçe - Bahçe Malmüdürlüğü",
    "OSMANİYE/Düziçi - Düziçi Malmüdürlüğü",
    "OSMANİYE/Hasanbeyli - Hasanbeyli Malmüdürlüğü",
    "OSMANİYE/Sumbas - Sumbas Malmüdürlüğü",
    "OSMANİYE/Toprakkale - Toprakkale Malmüdürlüğü",
    "OSMANİYE/Merkez - Osmaniye Vergi Dairesi Müdürlüğü",
    "OSMANİYE/Kadirli - Kadirli Vergi Dairesi Müdürlüğü",
    "DÜZCE/Cumayeri - Cumayeri Malmüdürlüğü",
    "DÜZCE/Çilimli - Çilimli Malmüdürlüğü",
    "DÜZCE/Gölyaka - Gölyaka Malmüdürlüğü",
    "DÜZCE/Gümüşova - Gümüşova Malmüdürlüğü",
    "DÜZCE/Kaynaşlı - Kaynaşlı Malmüdürlüğü",
    "DÜZCE/Yığılca - Yığılca Malmüdürlüğü",
    "DÜZCE/Merkez - Düzce Vergi Dairesi Müdürlüğü",
    "DÜZCE/Akçakoca - Akçakoca Vergi Dairesi Müdürlüğü",
];
